import dynamic from 'next/dynamic'

export const DynamicMembershipChangeModal = dynamic(
  () => import('.').then((mod) => mod.MembershipChangeModal),
  { ssr: false },
)
